export function formatJson(data) {
  try {
    const json = typeof data === "string" ? JSON.parse(data) : data;
    return JSON.stringify(json, null, 2);
  } catch (error) {
    console.error("JSON formatting error:", error);
    return data;
  }
}
